<template>
  <div>
    <navApp></navApp>
  </div>
</template>
<script>
// @ is an alias to /src
import NavApp from "@/view/Menu/Index.vue";
import { mapGetters } from "vuex";
import { getCurrentUser, checkAllTokens, logout } from "@/models/User.js";

export default {
  name: "app",
  components: {
    NavApp,
  },
  data: () => ({
    interval: null,
  }),
  created() {
    let time = 1000 * 60 * 60 * 12;
  },
  mounted() {
    this.tryAutoLogin()
  },
  computed: {
    ...mapGetters(["hasTokens"]),
  },
  methods: {
    async tryAutoLogin() {
      try {
        if (this.hasTokens) {
          let isValid = await checkAllTokens();
          if (isValid) {
            await getCurrentUser();
            if (this.$route.name === "Login") {
              this.$router.push("home");
            }
            return;
          }
        }
        // throw "User not authenticated"
      } catch (error) {
        // console.error(error);
        logout()
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss">
@import "@/plugins/styles/_font-style.scss";
@import url('../public/fonts/inter.css');
*, body, v-application{
  font-family: "Inter";
}

</style>
